import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
class EcashDescriptionComponent {
    constructor() {
        this.googleIconName1 = 'credit_card';
        this.googleIconName2 = 'qr_code_scanner';
        this.googleIconName3 = 'emoji_events';
    }
    ngOnInit() { }
}
EcashDescriptionComponent.ɵfac = function EcashDescriptionComponent_Factory(t) { return new (t || EcashDescriptionComponent)(); };
EcashDescriptionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EcashDescriptionComponent, selectors: [["fgbcl-ecash-description"]], inputs: { googleIconName1: "googleIconName1", googleIconName2: "googleIconName2", googleIconName3: "googleIconName3" }, decls: 36, vars: 15, consts: [[1, "ecash-description-box", "border", "border-disabled", "rounded", "shadow", "py-3", "pl-4", "pr-1", "px-lg-4"], [1, "text-primary", "text-center", "text-black", "font-weight-bold"], [1, "vertical-line"], [1, "d-flex", "flex-row", "flex-wrap", "flex-lg-nowrap", "justify-content-lg-around", "mt-3", "ml-2"], [1, "d-flex", "flex-column", "flex-nowrap", "mx-2", "py-2"], [1, "d-flex", "flex-row", "justify-content-center", "align-items-center"], [1, "ecash-description-icon", "centered", "position-relative"], [1, "ecash-description-number", "position-absolute", "centered", "color-1"], ["aria-hidden", "true", 1, "icon", "material-icons", "ecash-description", "color-1"], [1, "font-size-12", "pl-3", "pr-lg-4"], [1, "ecash-description-number", "position-absolute", "centered", "color-2"], ["aria-hidden", "true", 1, "icon", "material-icons", "ecash-description", "color-2"], [1, "ecash-description-number", "position-absolute", "centered", "color-3"], ["aria-hidden", "true", 1, "icon", "material-icons", "ecash-description", "color-3"], [1, "font-size-12", "pl-3"]], template: function EcashDescriptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h5", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "hr", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtext(10, "1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span", 8);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 4);
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵelementStart(18, "div", 6);
        ɵngcc0.ɵɵelementStart(19, "div", 10);
        ɵngcc0.ɵɵtext(20, "2");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "span", 11);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 9);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 4);
        ɵngcc0.ɵɵelementStart(27, "div", 5);
        ɵngcc0.ɵɵelementStart(28, "div", 6);
        ɵngcc0.ɵɵelementStart(29, "div", 12);
        ɵngcc0.ɵɵtext(30, "3");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "span", 13);
        ɵngcc0.ɵɵtext(32);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "div", 14);
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 7, "payment.description.title"));
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 9, "payment.description.step.one"));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName2);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 11, "payment.description.step.two"));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName3);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(35, 13, "payment.description.step.three"));
    } }, pipes: [ɵngcc1.TranslatePipe], styles: [".centered[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}"] });
EcashDescriptionComponent.ctorParameters = () => [];
EcashDescriptionComponent.propDecorators = {
    googleIconName1: [{ type: Input }],
    googleIconName2: [{ type: Input }],
    googleIconName3: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EcashDescriptionComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ecash-description',
                template: "<div class=\"ecash-description-box border border-disabled rounded shadow py-3 pl-4 pr-1 px-lg-4\">\r\n  <h5 class=\"text-primary text-center text-black font-weight-bold\">{{ 'payment.description.title' | translate }}</h5>\r\n  <hr class=\"vertical-line\" />\r\n  <div class=\"d-flex flex-row flex-wrap flex-lg-nowrap justify-content-lg-around mt-3 ml-2\">\r\n    <!--Col 1-->\r\n    <div class=\"d-flex flex-column flex-nowrap mx-2 py-2\">\r\n      <div class=\"d-flex flex-row justify-content-center align-items-center\">\r\n        <div class=\"ecash-description-icon centered position-relative\">\r\n          <div class=\"ecash-description-number position-absolute centered color-1\">1</div>\r\n          <span class=\"icon material-icons ecash-description color-1\" aria-hidden=\"true\">{{ googleIconName1 }}</span>\r\n        </div>\r\n        <div class=\"font-size-12 pl-3 pr-lg-4\">{{ 'payment.description.step.one' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <!--Col 2-->\r\n    <div class=\"d-flex flex-column flex-nowrap mx-2 py-2\">\r\n      <div class=\"d-flex flex-row justify-content-center align-items-center\">\r\n        <div class=\"ecash-description-icon centered position-relative\">\r\n          <div class=\"ecash-description-number position-absolute centered color-2\">2</div>\r\n          <span class=\"icon material-icons ecash-description color-2\" aria-hidden=\"true\">{{ googleIconName2 }}</span>\r\n        </div>\r\n        <div class=\"font-size-12 pl-3 pr-lg-4\">{{ 'payment.description.step.two' | translate }}</div>\r\n      </div>\r\n    </div>\r\n    <!--Col 3-->\r\n    <div class=\"d-flex flex-column flex-nowrap mx-2 py-2\">\r\n      <div class=\"d-flex flex-row justify-content-center align-items-center\">\r\n        <div class=\"ecash-description-icon centered position-relative\">\r\n          <div class=\"ecash-description-number position-absolute centered color-3\">3</div>\r\n          <span class=\"icon material-icons ecash-description color-3\" aria-hidden=\"true\">{{ googleIconName3 }}</span>\r\n        </div>\r\n        <div class=\"font-size-12 pl-3\">{{ 'payment.description.step.three' | translate }}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [".centered{display:flex;justify-content:center;align-items:center}"]
            }]
    }], function () { return []; }, { googleIconName1: [{
            type: Input
        }], googleIconName2: [{
            type: Input
        }], googleIconName3: [{
            type: Input
        }] }); })();

class EcashDescriptionModule {
}
EcashDescriptionModule.ɵfac = function EcashDescriptionModule_Factory(t) { return new (t || EcashDescriptionModule)(); };
EcashDescriptionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EcashDescriptionModule });
EcashDescriptionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CarouselModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EcashDescriptionModule, { declarations: function () { return [EcashDescriptionComponent]; }, imports: function () { return [CommonModule,
        CarouselModule, ɵngcc1.TranslateModule]; }, exports: function () { return [EcashDescriptionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EcashDescriptionModule, [{
        type: NgModule,
        args: [{
                declarations: [EcashDescriptionComponent],
                imports: [
                    CommonModule,
                    CarouselModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [EcashDescriptionComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { EcashDescriptionComponent, EcashDescriptionModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-ecash-ecash-description.js.map